import React from 'react';
import './TrendingTopics.css';
import { NavLink } from 'react-router-dom';
import { FaRegCalendarAlt } from 'react-icons/fa';

const TechnologyNews = ({ data }) => {
  const getColorClass = (name) => {
    const key = name?.toLowerCase().replace(/\s/g, '');
    const colors = {
      recipes: 'bg-red',
      fastfood: 'bg-orange',
      vegetables: 'bg-purple',
      tips: 'bg-blue',
    };
    return colors[key] || 'bg-default';
  };

  if (!data || data.length === 0) {
    return (
      <div className="loader-container">
        <div className="loader"></div>
        <div className="loader-text">Loading trending topics...</div>
      </div>
    );
  }

  const featured = data[0];
  const others = data.slice(1, 3);

  return (
    <section className="tech-news-section">
      <div className="section-header">
        <h2>Trending Topics</h2>
      </div>

      <div className="tech-news-grid">
        {featured && (
          <NavLink to={`/category/${featured.slug}`} className="featured-article">
            <img
              src={`https://api.funfillia.com/${featured.thumbnail}`}
              alt={featured.name}
              title={featured.title}
            />
            <span className={`news-tag ${getColorClass(featured.name)}`}>
              {featured.name}
            </span>
            <p className="meta"><FaRegCalendarAlt/> {new Date(featured.updated_at).toLocaleDateString()}</p>
          </NavLink>
        )}

        <div className="side-articles">
          {others.map((topic) => (
            <NavLink to={`/category/${topic.slug}`} className="article-card" key={topic.id}>
              <img
                src={`https://api.funfillia.com/${topic.thumbnail}`}
                alt={topic.name}
                title={topic.title}
              />
              <span className={`news-tag ${getColorClass(topic.name)}`}>
                {topic.name}
              </span>
              <p className="meta"><FaRegCalendarAlt/> {new Date(topic.updated_at).toLocaleDateString()}</p>
            </NavLink>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TechnologyNews;
